module.exports = __webpack_public_path__ + "img/reception.051c9629.svg";